import {
  BaseElementWidget,
  DslRender,
  ListPaginationStyle,
  SPI,
  TableWidget,
  TableWidgetProps,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import AutoAllocConsoleHistory from './AutoAllocConsoleHistory.vue';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: 'AutoAllocConsoleHistoryWidget'
  })
)
export class AutoAllocConsoleHistoryWidget extends TableWidget {

  public initialize(props: TableWidgetProps): this {
    super.initialize(props);
    this.setCurrentDataSource([]);
    this.setComponent(AutoAllocConsoleHistory);
    return this;
  }

  @Widget.Reactive()
  protected get showPagination() {
    return false;
  }

  @Widget.Reactive()
  protected get paginationStyle(): ListPaginationStyle {
    return ListPaginationStyle.HIDDEN;
  }

  @Widget.Reactive()
  protected get rowFieldsVNodes() {
    let fields: any =
      this.metadataRuntimeContext.viewDsl?.widgets.find(
        (w) => w.slot === 'table'
      );

    if (fields) {
      fields = fields.widgets.map((w, index) =>
        DslRender.render({
          ...w,
          __index: index
        })
      );

      return fields;
    }

    return null;
  }

}